<template>
  <div class="donor-phones">
    <b-button
      class="float-right"
      @click="editRow(-1)"
      right
      size="sm"
      variant="primary"
    >
      <font-awesome-icon icon="plus" />{{ $t("Добавить") }}
    </b-button>
    <table
      class="table-striped table mb-0 dx-g-bs4-overflow-hidden dx-g-bs4-table"
    >
      <thead>
        <tr>
          <th v-if="!isReadonly" class="edit-cell"></th>
          <th>Телефон</th>
          <th v-if="!isReadonly" class="delete-cell"></th>
        </tr>
      </thead>
      <tbody>
        <template v-if="data && data.length > 0">
          <tr
            v-for="(row, index) in data"
            :key="'phone-row-' + index + '-' + renderKey"
          >
            <td v-if="!isReadonly">
              <a class="edit" @click="editRow(index)" href="javascript:void(0)">
                <i class="fa fa-pencil-alt"></i>
              </a>
            </td>
            <td>{{ row.phone_number }}</td>
            <td v-if="!isReadonly">
              <a
                class="delete"
                @click="deleteRow(data, index)"
                href="javascript:void(0)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td :colspan="!isReadonly ? 3 : 1" class="text-center">Нет данных</td>
          </tr>
        </template>
      </tbody>
    </table>
    <b-modal
      id="edit-phone-modal"
      :title="$t('Телефон донора')"
      @keydown.native.enter="save"
      :no-close-on-backdrop="true"
      :cancel-disabled="false"
    >
      <rdkm-input
        :label="$t('Телефон')"
        v-model="row.phone_number"
        :cols="8"
        :mask="'+998 ## ###-##-##'"
        validate="required"
        :labelCols="3"
      ></rdkm-input>
      <div slot="modal-footer" class="w-100">
        <div class="offset-md-3">
          <b-button
            :disabled="errors.any()"
            @click="save"
            size="sm"
            variant="primary"
            class="mr-1"
          >
            <font-awesome-icon icon="check" /> {{ $t("Сохранить") }}
          </b-button>
          <b-button
            @click="hideModal('edit-phone-modal')"
            size="sm"
            variant="default"
          >
            <font-awesome-icon icon="times" /> {{ $t("Отмена") }}
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import GridMixin from "@/components/grid/Grid.mixin";
import ModalMixin from "@/mixins/modal.mixin";

export default {
  name: "DonorPhones",
  mixins: [GridMixin, ModalMixin],
  props: ["id", "data", "isReadonly"],
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  data() {
    return {
      row: {},
      initRow: { phone_number: "", donor_id: "" },
      currentIndex: -1,
      renderKey: 0,
    };
  },
  methods: {
    editRow(index) {
      this.row = Object.assign(
        {},
        index >= 0 ? this.data[index] : this.initRow
      );
      this.currentIndex = index;
      this.showModal("edit-phone-modal");
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.row.donor_id = this.id;
          if (this.currentIndex >= 0) {
            this.data[this.currentIndex] = this.row;
          } else {
            this.data.push(this.row);
          }
          this.renderKey++;
          this.hideModal("edit-phone-modal");
        }
      });
    },
  },
};
</script>
